import { useGetPyqYears } from "../hooks/useGetPyqYears";
import usePyqRedux from "../hooks/usePyqRedux";
import "./YearsList.css";

const YearsList = () => {
  const { data } = useGetPyqYears();
  const { pyqCurrentYear, setPyqCurrentYear } = usePyqRedux();
  return (
    <div className="pyq-years-list">
      <select
        onChange={(e) => setPyqCurrentYear(e.target.value)}
        className="pyq-years-list-dropdown"
        value={pyqCurrentYear}
      >
        {data?.map((ele) => (
          <option key={ele.year}>{ele.year}</option>
        ))}
      </select>
    </div>
  );
};

export default YearsList;
